import React from 'react';
import { Input, Button, Select, InputNumber } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

interface QueryParamsProps {
  year: number;
  month: number;
  deptFrom: string;
  deptTo: string;
  empFrom: string;
  empTo: string;
  deptLevel: number;
  company: number;
  loading: boolean;
  onYearChange: (v: number) => void;
  onMonthChange: (v: number) => void;
  onDeptFromChange: (v: string) => void;
  onDeptToChange: (v: string) => void;
  onEmpFromChange: (v: string) => void;
  onEmpToChange: (v: string) => void;
  onDeptLevelChange: (v: number) => void;
  onCompanyChange: (v: number) => void;
  onQuery: () => void;
}

const monthOptions = Array.from({ length: 12 }, (_, i) => ({
  value: i + 1,
  label: String(i + 1).padStart(2, '0'),
}));

const deptLevelOptions = [
  { value: 1, label: '1-部' },
  { value: 2, label: '2-處' },
  { value: 3, label: '3-課' },
  { value: 4, label: '4-組' },
];

const companyOptions = [
  { value: 1, label: '1-台北渤揚' },
  { value: 2, label: '2-昆山渤揚' },
  { value: 3, label: '3-全部' },
];

const QueryParams: React.FC<QueryParamsProps> = ({
  year, month, deptFrom, deptTo, empFrom, empTo, deptLevel, company, loading,
  onYearChange, onMonthChange, onDeptFromChange, onDeptToChange,
  onEmpFromChange, onEmpToChange, onDeptLevelChange, onCompanyChange, onQuery,
}) => {
  return (
    <div className="bg-gray-50 border border-gray-200 rounded p-4 mb-4">
      {/* Row 1: Department range */}
      <div className="flex flex-wrap items-center gap-4 mb-3">
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium" style={{ width: 96 }}>部門代號[從]</span>
          <Input
            value={deptFrom}
            onChange={(e) => onDeptFromChange(e.target.value.toUpperCase())}
            placeholder="起"
            style={{ width: 100 }}
            maxLength={4}
          />
          <span className="text-sm">[至]</span>
          <Input
            value={deptTo}
            onChange={(e) => onDeptToChange(e.target.value.toUpperCase())}
            placeholder="迄"
            style={{ width: 100 }}
            maxLength={4}
          />
        </div>
      </div>

      {/* Row 2: Employee range */}
      <div className="flex flex-wrap items-center gap-4 mb-3">
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium" style={{ width: 96 }}>人員代號[從]</span>
          <Input
            value={empFrom}
            onChange={(e) => onEmpFromChange(e.target.value.toUpperCase())}
            placeholder="起"
            style={{ width: 100 }}
            maxLength={8}
          />
          <span className="text-sm">[至]</span>
          <Input
            value={empTo}
            onChange={(e) => onEmpToChange(e.target.value.toUpperCase())}
            placeholder="迄"
            style={{ width: 100 }}
            maxLength={8}
          />
        </div>
      </div>

      {/* Row 3: Dept level + Company */}
      <div className="flex flex-wrap items-center gap-4 mb-3">
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium" style={{ width: 96 }}>部門分級</span>
          <Select
            value={deptLevel}
            onChange={onDeptLevelChange}
            options={deptLevelOptions}
            style={{ width: 100 }}
          />
        </div>
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium">公司分級</span>
          <Select
            value={company}
            onChange={onCompanyChange}
            options={companyOptions}
            style={{ width: 140 }}
          />
        </div>
      </div>

      {/* Row 4: Year / Month */}
      <div className="flex flex-wrap items-center gap-4 mb-3">
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium" style={{ width: 96 }}>年度月份</span>
          <InputNumber
            value={year}
            onChange={(v) => onYearChange(v ?? 2024)}
            min={1990}
            max={2099}
            style={{ width: 90 }}
          />
          <span className="text-sm">年</span>
          <Select
            value={month}
            onChange={onMonthChange}
            options={monthOptions}
            style={{ width: 70 }}
          />
          <span className="text-sm">月</span>
        </div>
      </div>

      {/* Query button */}
      <div className="flex gap-2">
        <Button type="primary" icon={<SearchOutlined />} onClick={onQuery} loading={loading}>
          查詢
        </Button>
      </div>
    </div>
  );
};

export default QueryParams;
